var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#E61F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.329 23.989H24.657V28.267C25.0703 27.8123 25.649 27.4403 26.393 27.151C27.137 26.8617 27.943 26.717 28.811 26.717C30.361 26.717 31.6423 27.0683 32.655 27.771C33.6883 28.4737 34.4427 29.383 34.918 30.499C35.3933 31.615 35.631 32.824 35.631 34.126C35.631 36.544 34.949 38.466 33.585 39.892C32.221 41.2973 30.299 42 27.819 42C26.1657 42 24.7293 41.721 23.51 41.163C22.2907 40.5843 21.3503 39.7887 20.689 38.776C20.0277 37.7633 19.666 36.5957 19.604 35.273H24.781C24.905 35.9137 25.2047 36.451 25.68 36.885C26.1553 37.2983 26.8063 37.505 27.633 37.505C28.6043 37.505 29.3277 37.195 29.803 36.575C30.2783 35.955 30.516 35.1283 30.516 34.095C30.516 33.0823 30.268 32.3073 29.772 31.77C29.276 31.2327 28.5527 30.964 27.602 30.964C26.8993 30.964 26.3207 31.1397 25.866 31.491C25.4113 31.8217 25.1117 32.266 24.967 32.824H19.852V19.339H34.329V23.989ZM41.5641 42.248C40.6341 42.248 39.8694 41.9793 39.2701 41.442C38.6914 40.884 38.4021 40.202 38.4021 39.396C38.4021 38.5693 38.6914 37.877 39.2701 37.319C39.8694 36.761 40.6341 36.482 41.5641 36.482C42.4734 36.482 43.2174 36.761 43.7961 37.319C44.3954 37.877 44.6951 38.5693 44.6951 39.396C44.6951 40.202 44.3954 40.884 43.7961 41.442C43.2174 41.9793 42.4734 42.248 41.5641 42.248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberFive);
export default __webpack_public_path__ + "static/media/number-five.25f32194.svg";
export { ForwardRef as ReactComponent };